import { Api6Error } from 'api/api.types'
import { definitions } from 'api/generated/ratings_v2.voting'
import { RatingPromo } from 'components/page/PhotoRating/PhotoRating.constants'

interface LocationPhotoRating {
  country: number
  region: number
  city: number
  metro: number
  location: string
}

interface LocationPhotoRatingPosition extends LocationPhotoRating {
  countryName: string
  regionName: string
  cityName: string
  metroName: string
}

interface LocationPhotoRatingLocationString
  extends LocationPhotoRatingPosition {
  locationString: string
}

export interface VisitedCountries {
  id: number
  name: string
  flag: string
  date: string
  flagLink: string
}

export interface PhotoRatingState {
  currentLocationAutocomplete: LocationPhotoRatingLocationString
  votingPhotos: definitions['RatingVotingPhoto'][]
  /**
   * При кешировании мы не можем завязываться на votingPhotos,
   * так как он меняется при голосовании.
   * Поэтому сделал отдельный массив(updatedFullVotingPhotosAfterFetch), который меняется только после
   * запроса на update очереди
   */
  updatedFullVotingPhotos: definitions['RatingVotingPhoto'][]
  pastVotingPhotos: definitions['RatingVotingPhoto'][]
  cachePastVotingPhotos: definitions['RatingVotingPhoto'][]
  /** Удалить после релиза: голосования могут идти в параллельно */
  voting: boolean
  votingPhotosLoaded: boolean
  votingPhotosFetchingFailed: boolean
  match: definitions['RatingMatch'] | null

  /** Выбранная позиция промо в текущем интервале */
  currentPromoIndex: number
  /** Вид промо */
  currentPromo: RatingPromo | null
  /** Количество лайков сделанных пользователем */
  votedCounter: number
  likedCounter: number
  /**
   * На сколько шагов мы уйдем назад, и флаг как долго не увеличивать
   * votedCounter и likedCounter пока revertCounter снова не будет равен null
   */
  revertCounter: null | number

  /**
   * Последняя позиция по счетчику лайков, на которой юзер скрыл нотис инкогнито.
   * Нужен, чтобы уметь скрывать этот нотис.
   */
  lastIncognitoNoticeShownAtLikedCount: number

  photoOwnerId: number | null
  disliking: boolean
  liking: boolean

  mobileInfoToggle: boolean
  isVisibleDraggableCard: boolean
  isTutorialVisible: boolean
  isVisiblePromoGuaranteedTips: boolean
  error?: Api6Error
  errorStatus?: number
  /**
   * Есть ли в ротации фото для фоторейтинга.
   * Используется для того что бы показывать либо не показывать
   * промо покупки показов.
   * null когда нет информации о фото в ротации.
   */
  featuredPhotosActive: boolean | null

  /** https://redmine.mamba.ru/issues/114190 */
  shouldAskPhoto: {
    showUploader: boolean
  }
}

export enum ButtonType {
  Liking = 'liking',
  Disliking = 'disliking',
  Revert = 'revert',
  Gift = 'gift',
  Message = 'message',
}

export const initialState: PhotoRatingState = {
  currentLocationAutocomplete: {
    country: 0,
    region: 0,
    city: 0,
    metro: 0,
    location: '',
    countryName: '',
    regionName: '',
    cityName: '',
    metroName: '',
    locationString: '',
  },
  votingPhotos: [],
  updatedFullVotingPhotos: [],
  pastVotingPhotos: [],
  cachePastVotingPhotos: [],
  photoOwnerId: null,
  voting: false,
  liking: false,
  disliking: false,
  votingPhotosLoaded: false,
  votingPhotosFetchingFailed: false,
  match: null,

  /** То что касается промо */
  currentPromoIndex: 0,
  currentPromo: null,
  votedCounter: 0,
  likedCounter: 0,
  lastIncognitoNoticeShownAtLikedCount: 0,

  featuredPhotosActive: null,

  mobileInfoToggle: false,
  isVisibleDraggableCard: true,
  isTutorialVisible: false,
  isVisiblePromoGuaranteedTips: false,

  shouldAskPhoto: {
    showUploader: false,
  },
  revertCounter: null,
}
